module.exports = __webpack_public_path__ + "static/media/5.d9eb6d9d.JPG";